import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { createAiThread, listAiThreads } from "@/lib/ai-assistant.functions";
import { useEffect } from "react";
import { Sparkles } from "lucide-react";
import { z } from "zod";

export const Route = createFileRoute("/_authenticated/admin/ai/")({
  validateSearch: z.object({ q: z.string().optional() }),
  component: AiIndex,
});

function AiIndex() {
  const listFn = useServerFn(listAiThreads);
  const createFn = useServerFn(createAiThread);
  const nav = useNavigate();
  const { q } = Route.useSearch();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      // If a prompt is provided, always start a fresh thread so the
      // dashboard shortcut lands in its own conversation.
      const target = q
        ? await createFn({ data: {} })
        : (await listFn())[0] ?? (await createFn({ data: {} }));
      if (cancelled || !target) return;
      nav({
        to: "/admin/ai/$threadId",
        params: { threadId: target.id },
        search: q ? { q } : {},
        replace: true,
      });
    })();
    return () => {
      cancelled = true;
    };
  }, [listFn, createFn, nav, q]);

  return (
    <div className="flex h-full items-center justify-center text-muted-foreground">
      <div className="flex items-center gap-2 text-sm">
        <Sparkles className="h-4 w-4 animate-pulse text-primary" />
        Opening Plunkets AI…
      </div>
    </div>
  );
}
